import { render, staticRenderFns } from "./ManagedList.vue?vue&type=template&id=0a79d56a&scoped=true"
import script from "./ManagedList.vue?vue&type=script&lang=js"
export * from "./ManagedList.vue?vue&type=script&lang=js"
import style0 from "./ManagedList.vue?vue&type=style&index=0&id=0a79d56a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a79d56a",
  null
  
)

export default component.exports